import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Icon, Modal, Popup, Table } from "semantic-ui-react";

import { getPriceForDisplay } from "../../modules/Appointments/util";

import Service from "./service";

import "./ROBServiceRequest.scss";

export const ROB_SERVICE_REQUEST_STATUS_COLORS = {
  Approved: "green",
  ProvisionallyApproved: "orange",
  Denied: "red",
};

class ROBServiceRequest extends Component {
  state = {
    serviceRequest: null,
    isModalVisible: false,
  };

  componentDidMount() {
    this.handleGetROBServiceRequest();
  }

  handleGetROBServiceRequest = () => {
    const { appointment, isRobnetEnabled } = this.props;

    if (!isRobnetEnabled || !appointment.wo_nr) return;

    Service.getROBServiceRequest({ car_id: appointment.car_id })
      .then(res => {
        const serviceRequest = res.data.data?.data;

        if (!serviceRequest || serviceRequest.appointment.workOrderNumber !== appointment.wo_nr) return;

        this.setState({ serviceRequest });
      })
      .catch(err => {
        console.error("Error getting ROB service request", err);
      });
  };

  handleToggleDisplayModal = () => {
    this.setState(({ isModalVisible }) => ({ isModalVisible: !isModalVisible }));
  };

  renderComponentRow = component => {
    const failureCodes = component.denialReasons ? component.denialReasons.map(denialReason => denialReason.code).join(" ") : "";

    return (
      <Table.Row key={component.id}>
        <Table.Cell>{`${component.rob.code} ${component.rob.description}`}</Table.Cell>
        <Table.Cell>{`${component.operation.code} ${component.operation.description}, ${component.reason.code} ${component.reason.description}`}</Table.Cell>
        <Table.Cell>{`€ ${getPriceForDisplay(component.price)}`}</Table.Cell>
        <Table.Cell>{failureCodes}</Table.Cell>
        <Table.Cell>{component.status.description}</Table.Cell>
      </Table.Row>
    );
  };

  renderROBServiceRequestModal = () => {
    const { t } = this.props;
    const { serviceRequest } = this.state;

    return (
      <Modal open={true} className="ROBServiceRequestModal">
        <Modal.Header className="modal-header">
          <div>{t("rob_request").message || "ROB Request"}</div>
          <div className="header-actions">
            <Button basic disabled>
              <Icon name="external" />
              ROB Portal
            </Button>
            <Button color="green" onClick={this.handleToggleDisplayModal}>
              {t("close").message || "Close"}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={3}>{t("activity").message || "Activity"}</Table.HeaderCell>
                <Table.HeaderCell width={5}>{t("details").message || "Details"}</Table.HeaderCell>
                <Table.HeaderCell width={2}>{t("amount").message || "Amount"}</Table.HeaderCell>
                <Table.HeaderCell width={4}>{t("failure_code").message || "Failure code"}</Table.HeaderCell>
                <Table.HeaderCell width={2}>{t("status").message || "Status"}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{serviceRequest.components.map(this.renderComponentRow)}</Table.Body>
          </Table>
          <div className="approved-total">
            {`${t("approved_total").message || "Approved total"}:`}
            <strong>{`€ ${getPriceForDisplay(serviceRequest.invoicing.totalAmountApproved)}`}</strong>
          </div>

          {serviceRequest.remarks.supplier && (
            <div className="remark-row">
              <div className="remark-title">{t("supplier_comments").message || "Supplier comments"}</div>
              <div className="remark-value">{serviceRequest.remarks.supplier}</div>
            </div>
          )}

          {serviceRequest.remarks.lessor && (
            <div className="remark-row">
              <div className="remark-title">{t("leasing_company_comments").message || "Leasing company comments"}</div>
              <div className="remark-value">{serviceRequest.remarks.lessor}</div>
            </div>
          )}
        </Modal.Content>
      </Modal>
    );
  };

  render() {
    const { t } = this.props;
    const { serviceRequest, isModalVisible } = this.state;

    if (!serviceRequest) return null;

    return (
      <div className="ROBServiceRequest">
        <Popup
          disabled={!serviceRequest.serviceRequestNumber}
          position="top center"
          content={
            <div className="request-popup">
              <div>{`${t("status").message || "Status"}: ${serviceRequest.status}`}</div>
              <div>{`${t("service_request_number").message || "Service request number"}: ${serviceRequest.serviceRequestNumber}`}</div>
            </div>
          }
          trigger={
            <Button
              basic
              fluid
              color={ROB_SERVICE_REQUEST_STATUS_COLORS[serviceRequest.status] || "grey"}
              onClick={this.handleToggleDisplayModal}
              className="ROBServiceRequestButton"
            >
              {t("rob_request").message || "ROB Request"}
            </Button>
          }
        />
        {isModalVisible && this.renderROBServiceRequestModal()}
      </div>
    );
  }
}

export default withTranslation()(ROBServiceRequest);
